export default __webpack_public_path__ + "static/media/systolic.869a831a.svg";